module.exports = __webpack_public_path__ + "img/channel-bg.09102b61.png";